export default __webpack_public_path__ + "static/media/jkr.3df8ff32.png";